import { url, header } from "../../apis/Index";
import { toast } from "react-toastify";
import axios from "axios";

export const getFundTypes = () => {
  return (dispatch) => {
    axios
      .get(`${url}/v1/fund-types`, {
        headers: header,
      })
      .then((funds) => {
        dispatch({
          type: "GET_FUND_TYPES",
          funds,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const addnewFundType = (newFund) => {
  return (dispatch) => {
    axios
      .post(`${url}/v1/fund-types`, newFund, {
        headers: header,
      })
      .then((fund) => {
        dispatch({
          type: "CREATE_FUND_TYPE",
          fund,
        });
        toast.success("Fund type registered", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };
};

export const updateFundType = (updatedFund, id) => {
  return (dispatch) => {
    axios
      .put(`${url}/v1/fund-types/${id}`, updatedFund, {
        headers: header,
      })
      .then((fund) => {
        dispatch({
          type: "UPDATE_FUND_TYPE",
          fund,
        });
      })
      .catch((error) => {
        console.log(error);
        toast.error("Failed to update fund type", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000,
        });
      });
  };
};

export const deleteFundType = (id) => {
  return (dispatch) => {
    axios
      .delete(`${url}/v1/fund-types/${id}`, {
        headers: header,
      })
      .then(() => {
        dispatch({
          type: "DELETE_FUND_TYPE",
          id,
        });
      })
      .catch((error) => {
        console.log(error);
        toast.error("Failed to delete fund", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000,
        });
      });
  };
};
